import dayjs from 'dayjs';
import Cookie from 'js-cookie';
import { assign } from '@atds-legacy/lang';
import { Record, Resource, SDK } from '@redge-media/fo-js-sdk';
import { CookieName, HeaderName } from '@/shared/enums';
import { generateCookie } from './bookmark-cookie';
import destroy from './destroy';
import remove from './remove';
import deserialize from './deserialize';

const Favourites = Resource.mixin(deserialize, destroy, remove).extend({
  endpoint: 'int/subscribers/bookmarks?type=FAVOURITE',
  cookieName: CookieName.FAVOURITE_HASH,

  constructor: function Favourites(subscriber, time) {
    Resource.call(assign(this, {
      subscriber,
      time,
    }));
  },

  getPath() {
    return 'subscribers/bookmarks?type=FAVOURITE';
  },

  refresh({ cookieRefresh } = {}) {
    if (cookieRefresh) {
      generateCookie({
        id: this.subscriber.id,
        name: this.cookieName,
        time: this.time.now,
      });
    }

    if (this.subscriber.isLogged) {
      return this.fetchAll({
        kids: this.subscriber.isKidsTheme,
        hash: Cookie.get(this.cookieName),
      }, { reset: true });
    }

    return this.collection.reset();
  },

  createRecord(props = {}, opts = {}) {
    if (props instanceof Record) {
      return props;
    }

    const item = props.item || props;
    item.createdAt = dayjs(props.createdAt);
    item.modifiedAt = dayjs(props.modifiedAt);
    return SDK.factory.resolve(item, opts);
  },

  create(record, opts = {}) {
    const method = 'post';
    return SDK.apiAdapter[method](this.endpoint, {
      itemId: record.id,
      profile: {
        token: this.subscriber.profile.token,
        id: this.subscriber.profile.id,
        name: this.subscriber.profile.name,
      },
    }, {
      headers: {
        [HeaderName.SUBSCRIBER_HASH]: Cookie.get(CookieName.SUBSCRIBER_HASH),
        [HeaderName.SUBSCRIBER_PUB]: Cookie.get(CookieName.SUBSCRIBER_PUB),
      },
    }).then(() => {
      generateCookie({
        id: this.subscriber.id,
        name: this.cookieName,
        time: this.time.now,
      });

      if (!opts.refresh) {
        this.collection.add(record, { parse: true, isFetched: true });
        this.emit('sync', method, record);
        return Promise.resolve(record);
      }

      return this.fetchAll('', { reset: true })
        .then(() => Promise.resolve(record));
    });
  },
});

export default Favourites;
